// @core/api/endpoints/notifications/update_team_member_overrides.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTeamMemberOverridesRequest,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Update team member notification overrides
 * Sets personal notification preferences for a team member that override the team's default settings. Allows individual customization within a team context.
 */
export async function UpdateTeamMemberOverrides(
  team_id: string,
  user_id: string,
  data: UpdateTeamMemberOverridesRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/teams/:team_id/members/:user_id/overrides`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
